//#region libraries
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
//bootstrap
import { Container, Row, Col, Image } from 'react-bootstrap';
//custom component
import { BookingCard, ConfirmNavigator, Contact } from '_molecules';
//styles
import { Colors } from '_styles';
//images
import image from "_assets/images/PRM-Logo-PNG/PRM-Assist-Logo-Col.png";
//#endregion
const ConfirmBooking = () => {
    //#region state
    // current page //
    const [page, setPage] = useState("booking");

    // hover variables
    const [contactHover, setContactHover] = useState(false);
    const [websiteHover, setWebsiteHover] = useState(false);
    //#endregion
    // navigation
    const history = useHistory();

    const changePage = (page) => {
        setPage(page)
    };
    return (
        <>
            <Container fluid={true}>
                <Row>

                    {/* Sidebar */}
                    <Col xs={4} className="vh-100 justify-content-md-center" style={{ borderRightStyle: 'solid', borderRightWidth: 1, borderRightColor: Colors.PRM_LIGHT_BLUE }}>

                        {/* Logo */}
                        <Container className="mt-5 justify-content-md-center d-inline-flex">
                            <Image
                                src={image}
                                height={50}
                            />
                        </Container>

                        {/* Title Text */}
                        <Container style={{ marginTop: 76 }}>
                            <p style={{ fontSize: 26, fontWeight: 'bold' }}>Welcome to PRM Assist</p>
                            <p style={{ fontSize: 18, fontWeight: '200' }}>PRM Assist is a platform which allows passengers with reduced mobility to make assistance requests to airports globally.</p>
                            <p style={{ fontSize: 18, fontWeight: '200' }}>Visit our <a onClick={() => { history.push("/") }} onMouseOver={() => { setWebsiteHover(true) }} onMouseLeave={() => { setWebsiteHover(false) }} style={{ color: Colors.PRM_LIGHT_BLUE, fontWeight: '200', textDecoration: websiteHover ? 'underline' : 'none', cursor: 'pointer' }}>website</a>  to find out more.</p>

                            <p style={{ fontSize: 26, fontWeight: 'bold' }}>What is a booking confirmation?</p>
                            <p style={{ fontSize: 18, fontWeight: '200' }}>By confirming a booking request we can update the passenger that their request for assistance has been received and confirmed by airport staff.</p>
                            <p style={{ fontSize: 18, fontWeight: '200' }}>Our goal is to connect passengers with airport staff by creating a communication channel. </p>
                            <p style={{ fontSize: 18, fontWeight: '200' }}>To contact us, <a onClick={() => { changePage('contact') }} onMouseOver={() => { setContactHover(true) }} onMouseLeave={() => { setContactHover(false) }} style={{ color: Colors.PRM_LIGHT_BLUE, fontWeight: '200', textDecoration: contactHover ? 'underline' : 'none', cursor: 'pointer' }}>click here.</a> </p>
                        </Container>

                    </Col>

                    {/* Content */}
                    <Col className="wh-100 mt-5">
                        <ConfirmNavigator setPage={setPage} page={page} />
                        {
                            page == "booking" ?
                                <BookingCard />
                                :
                                page == 'contact' ?
                                    <Contact setPage={setPage} />
                                    :
                                    <p>Error Loading Page</p>
                        }
                    </Col>

                </Row>
            </Container>
        </>
    );

}

export default ConfirmBooking;
